
import { History } from 'history';
import { AxiosInstance } from 'axios';
import userPool from './userPool';
import { STORAGE_REFRESH_TOKEN, STORAGE_TOKEN, USERNAME } from '../constants';
import {ensureAuthenticated, getAuthToken} from '../utils';



export const setupAuthInterceptor = (service: AxiosInstance, history?: History) => {

  service.interceptors.request.use(
    async (config) => {
      const token = await ensureAuthenticated(history);
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  service.interceptors.response.use(
    (response) => {
    
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        logoutUser(history); 
        if (history) {
          history.push('/auth'); 
        }
      }
      return Promise.reject(error);
    }
  );
};

function logoutUser(history:any) {
  const user = userPool.getCurrentUser();
  if (user) {
    user.signOut();
    sessionStorage.removeItem(STORAGE_TOKEN);
    sessionStorage.removeItem(STORAGE_REFRESH_TOKEN);
    sessionStorage.removeItem(USERNAME);
    if (history) {
      history.push('/auth'); 
    }
  } else {
    console.error('No user found in the current session.');
  }
};
 


